<template>
  <header :class="['header padding-y-2xl', { 'padding-top-4xl': accountView }]">
    <div
      v-if="hasLimitedOfferBadge"
      class="position-absolute"
      style="top: calc(var(--spacing-2xl) * -1); right: calc(var(--spacing-2xl) * -1); transform: rotate(15deg)"
    >
      <div class="position-relative text-center">
        <font-awesome-icon
          :icon="$v7.solid.faCertificate"
          size="7x"
          class="position-relative z-1"
          style="color: var(--fa-yellow)"
        />
        <span class="position-absolute z-2 display-block top-1 right-1 padding-lg">
          <span
            class="display-block margin-top-2xs"
            style="line-height: 1.2; font-weight: var(--font-weight-semibold)"
            >Limited Time Price!</span
          >
        </span>
      </div>
    </div>

    <font-awesome-icon
      :icon="$v7[planIconStyle][icon]"
      size="4x"
    />

    <h3
      v-if="!plan && !subscription && determinations.isBacker"
      class="margin-top-md"
    >
      <span class="display-block size-sm">Font Awesome 5</span>
      <span class="display-block size-lg">Early Backer</span>
    </h3>

    <h3
      v-if="planName"
      class="margin-y-4xs size-4xl"
    >
      {{ planName }}
      <span class="sr-only">Plan</span>
    </h3>

    <dl
      v-if="(plan || subscription) && !accountView"
      style="--list-padding-left: 0"
    >
      <dt class="sr-only">Cost:</dt>
      <dd
        class="text-center margin-bottom-0"
        style="font-weight: var(--font-weight-semibold)"
      >
        <span class="display-flex align-center">
          <span
            class="size-3xl"
            style="line-height: var(--line-height-sm)"
          >
            {{ currentDollars() }}
          </span>
          <span
            v-if="currentCents()"
            class="padding-top-4xs"
            style="align-self: flex-start; font-size: var(--font-size-lg)"
            >.{{ currentCents() }}</span
          >
        </span>
        <span class="display-block text-capitalize">{{ howLong }}</span>
      </dd>
      <dd v-if="hasAdditionalPricingDetails">
        then {{ nextYearDollars() }}<span v-if="nextYearCents()">.{{ nextYearCents() }}</span
        >/year
      </dd>
    </dl>
  </header>
</template>

<script>
  import { get } from 'lodash'
  import { mapGetters } from 'vuex'
  import { nextBilledAmount, getSubscriptionAmount, getCurrentDiscountLengthLabel, formatTotalCurrency, isProratedAmount } from 'app/views/plans/priceUtils'

  export default {
    name: 'PlanInfo',

    props: {
      plan: {
        type: Object
      },

      subscription: {
        type: Object
      },

      determinations: {
        type: Object
      },

      price: {
        type: Number
      },

      priceWithDiscount: {
        type: Number
      },

      seats: {
        type: Number
      },

      hasLimitedOfferBadge: {
        type: Boolean,
        default: false
      },

      isCurrentPlan: {
        type: Boolean
      },

      colorSet: {
        type: Object,
        required: true
      },

      isUpgrading: {
        type: Boolean,
        default: false
      },

      planIconStyle: {
        type: String
      },

      accountView: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      ...mapGetters('plans', ['subscriptionDiscounts']),

      planName() {
        const plan = this.plan || get(this.subscription, ['plan'])

        return get(plan, ['name'])
      },

      hasAdditionalPricingDetails() {
        if (this.subscriptionDiscounts.length > 0) {
          if (get(this.subscriptionDiscounts[0], 'duration') === 'forever') {
            return false
          } else {
            return true
          }
        }

        return false
      },

      subscriptionDiscount() {
        return get(this, ['subscription', 'discounts', 0])
      },

      amount() {
        let val = 0

        if (this.price) {
          val = this.price
        } else if (this.isCurrentPlan) {
          val = getSubscriptionAmount(this.subscription)
        } else {
          val = get(this, ['plan', 'price', 'amount'], 0)
        }

        return val / 100
      },

      howLong() {
        let val = ''

        if (parseInt(this.amount) === 0) {
          val = 'forever'
        } else {
          val = 'per year'

          if (isProratedAmount(this.subscription)) {
            val = 'prorated'
          }

          if (this.subscriptionDiscounts.length > 0) {
            val = getCurrentDiscountLengthLabel(this.subscriptionDiscounts[0])
          }

          if (this.isUpgrading) {
            val = 'due today'
          }
        }

        return val
      },

      icon() {
        const { indication, isBacker } = this.determinations

        if (!this.plan && isBacker) {
          return 'faSunrise'
        } else if (!this.plan && (indication === 'warning' || indication === 'danger')) {
          return 'faBomb'
        } else if (this.plan.iconName) {
          return this.plan.iconName
        } else if (this.plan.name === 'FA-FREE') {
          return 'faEarthAmericas'
        } else {
          return 'faPlanetRinged'
        }
      }
    },

    methods: {
      currentDollars() {
        return formatTotalCurrency(this.amount)[0]
      },

      currentCents() {
        return formatTotalCurrency(this.amount)[1]
      },

      nextYearDollars() {
        return nextBilledAmount(this.subscriptionDiscounts[0], this.amount, this.plan, this.seats)[0]
      },

      nextYearCents() {
        return nextBilledAmount(this.subscriptionDiscounts[0], this.amount, this.plan, this.seats)[1]
      }
    }
  }
</script>
